import SiteImage from "./SiteImage";
import { FooterTrustBadge } from "./TrustBadge";
import { Link } from "wouter";
import { Facebook, Instagram, Youtube } from "lucide-react";

const BASE_URL = import.meta.env.BASE_URL;

export default function SiteFooter({ showTrustBadge = true }: { showTrustBadge?: boolean }) {
  return (
    <footer className="bg-[#1A1A1A] text-white font-sans">
      {showTrustBadge && <FooterTrustBadge />}
      <div className="max-w-[1240px] mx-auto px-10 pt-[64px] pb-[30px] grid grid-cols-1 lg:grid-cols-[1.4fr_1fr_1fr] gap-12">
        {/* Brand */}
        <div>
          <SiteImage src={`${BASE_URL}reframe-logo.png`} alt="Reframe" className="h-[34px] w-auto block brightness-0 invert" />
          <p className="mt-[14px] text-[15.5px] leading-[1.55] text-white/55 max-w-[30ch]">
            Relevant to culture. Faithful to Scripture.
          </p>
          <a href="mailto:info@reframeyouth.com" className="inline-block mt-[16px] text-[15.5px] text-white/75 hover:text-white transition-colors">
            info@reframeyouth.com
          </a>
        </div>

        {/* Links */}
        <div>
          <div className="text-[11.5px] font-extrabold tracking-[0.15em] uppercase text-white/60 mb-4">Tools</div>
          <div className="flex flex-col gap-[11px]">
            <Link href="/shop" className="text-[15.5px] text-white/75 hover:text-white transition-colors">Curriculum</Link>
            <Link href="/about" className="text-[15.5px] text-white/75 hover:text-white transition-colors">About</Link>
            <Link href="/blog" className="text-[15.5px] text-white/75 hover:text-white transition-colors">Blog</Link>
            <Link href="/tools" className="text-[15.5px] text-white/75 hover:text-white transition-colors">Tools</Link>
            <Link href="/statement-of-faith" className="text-[15.5px] text-white/75 hover:text-white transition-colors">Statement of Faith</Link>
          </div>
        </div>

        {/* Socials */}
        <div>
          <div className="text-[11.5px] font-extrabold tracking-[0.15em] uppercase text-white/60 mb-4">Follow</div>
          <div className="flex flex-col gap-[11px]">
            <a href="https://www.instagram.com/reframeyouth/" target="_blank" rel="noopener noreferrer" className="text-[15.5px] text-white/75 hover:text-white transition-colors">Instagram</a>
            <a href="https://www.youtube.com/@reframeyouth" target="_blank" rel="noopener noreferrer" className="text-[15.5px] text-white/75 hover:text-white transition-colors">YouTube</a>
            <a href="https://www.tiktok.com/@reframeyouth" target="_blank" rel="noopener noreferrer" className="text-[15.5px] text-white/75 hover:text-white transition-colors">TikTok</a>
            <a href="https://www.facebook.com/reframeyouth" target="_blank" rel="noopener noreferrer" className="text-[15.5px] text-white/75 hover:text-white transition-colors">Facebook</a>
          </div>
        </div>
      </div>

      <div className="max-w-[1240px] mx-auto px-10 pt-[22px] pb-[40px] border-t border-white/10 flex justify-between gap-6 text-[13.5px] text-white/60">
        <span>© 2026 Reframe Youth. All rights reserved.</span>
        <div className="flex gap-5">
          <a href="https://reframeyouth.myshopify.com/policies/privacy-policy?_fd=0" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Privacy</a>
          <a href="https://reframeyouth.myshopify.com/policies/terms-of-service?_fd=0" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Terms</a>
        </div>
      </div>
    </footer>
  );
}
